import { Schema } from '@core/data/dto/schema';

export const TipSourceTipTypeSchema = {
    id: Schema.String,
    label: Schema.String,
    label_key: Schema.String,
    pay_via_payroll: Schema.Boolean
};
